
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: {
        completed: null,
        media: null
    }
}

const LinkMedias = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCT_LINK_MEDIA_REQUEST':
            return { loading: true, error: false, data: { completed: false, media: action.payload } }
        case 'PRODUCT_LINK_MEDIA_ERROR':
            return { loading: false, error: true, data: { completed: "error", media: action.payload } };
        case 'PRODUCT_LINK_MEDIA_SUCCESS':
            return { loading: false, error: false, data: { completed: true, media: action.payload } };
        case 'PRODUCT_LINK_MEDIA_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default LinkMedias